
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftLeft0 as ObiThreewayStackedInleftLeft0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-left-0.js';
 
 
 

 
 export const ObiThreewayStackedInleftLeft0 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-left-0',
   elementClass: ObiThreewayStackedInleftLeft0Element,
   events: {
     
   }
  });
 
 